<template>
  <div
    class="fixed inset-0 flex items-start justify-center px-4 py-6 mt-12 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
    style="z-index: 100"
    v-if="show"
  >
    <div
      id="toast"
      @click="resetTimer()"
      class="w-full max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg cursor-pointer pointer-events-auto hover:-translate-1"
    >
      <div class="relative overflow-hidden rounded-lg shadow-xs">
        <div class="px-4 py-5">
          <div class="flex items-center">
            <div class="shrink-0 pr-0.5">
              <template v-if="type == 'info'">
                <div class="w-10 h-10">
                  <svg
                    class="w-10 h-10 text-indigo-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
              </template>
              <template v-if="type == 'warning'">
                <div class="w-10 h-10">
                  <svg
                    class="w-10 h-10 text-amber-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    ></path>
                  </svg>
                </div>
              </template>
              <template v-if="type == 'success'">
                <div class="w-10 h-10">
                  <svg
                    class="w-10 h-10 text-emerald-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
              </template>
              <template v-if="type == 'danger'">
                <div class="w-10 h-10">
                  <svg
                    class="w-10 h-10 text-red-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
              </template>
            </div>
            <div class="flex-1 w-0 pl-3.5 ml-1 border-l border-gray-100">
              <p class="text-sm font-medium leading-5 text-gray-900">
                <template v-if="type == 'info'"><span>Notice</span></template>
                <template v-if="type == 'warning'"
                  ><span>Warning</span></template
                >
                <template v-if="type == 'success'"
                  ><span>Success</span></template
                >
                <template v-if="type == 'danger'"
                  ><span>Something went wrong</span></template
                >
              </p>
              <p class="text-sm leading-5 text-gray-500" v-html="message"></p>
            </div>
            <div class="flex self-start shrink-0 ml-4">
              <button
                @click="resetTimer()"
                class="inline-flex -mt-1 text-gray-400 transition duration-150 ease-in-out rounded-full focus:outline-none focus:text-gray-500"
                aria-label="Close-Message"
              >
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          id="toast_bar"
          class="absolute bottom-0 left-0 w-full h-1 anim100to0"
          :class="{
            'bg-indigo-400': type == 'info',
            'bg-amber-400': type == 'warning',
            'bg-emerald-400': type == 'success',
            'bg-red-400': type == 'danger',
          }"
          style="transition-duration: 4s"
        ></div>
      </div>
    </div>
  </div>
</template> 


<script>
export default {
  data() {
    return {
      show: false,
      timerVar: null,
    };
  },
  methods: {
    timer() {
      this.timerVar = setTimeout(() => {
        this.show = false;
        this.$store.commit("cleanFlashMessage");
      }, 3900);
    },
    resetTimer() {
      clearTimeout(this.timerVar);
      this.show = false;
      this.$store.commit("cleanFlashMessage");
    },
    showFlash() {
      if (!this.show && this.$store.state.flashMessage.message != null) {
        this.timer();
        this.show = true;
      }
    },
  },
  computed: {
    message() {
      this.showFlash();
      return this.$store.state.flashMessage.message;
    },
    type() {
      return this.$store.state.flashMessage.type == undefined
        ? "success"
        : this.$store.state.flashMessage.type;
    },
  },
  watch: {
    refresh: {
      handler() {
        this.message = this.flashMessage
          ? this.flashMessage
          : this.$page.props.flash.message;

        this.type = this.flashMessageType
          ? this.flashMessageType
          : this.$page.props.flash.message_type;

        if (this.type == "" || this.type == undefined) this.type = "success";

        if (!this.show) this.timer();

        this.show = true;
      },
    },
    message() {
      this.showFlash();
    },
  },
};
</script>